import { createSlice } from "@reduxjs/toolkit";
import { jwtDecode } from "jwt-decode";

const storedToken = localStorage.getItem("auth-token");
let decodedToken = null;
if (storedToken) {
  try {
    decodedToken = jwtDecode(storedToken);
     console.log("DECODED TOKEN AFTER REFRESH:", decodedToken);
  } catch (err) {
    console.error("Failed to decode token at startup:", err);
  }
}

const initialState = {
  accessToken: storedToken || null,
  userId: decodedToken?.id || null,
  email: decodedToken?.email || null,
  roles: decodedToken?.roles || [],
  role: decodedToken?.role || decodedToken?.roles?.[0] || null,

  phone: "",
  otp: "",
  firstName: null,
  lastName: null,
  status: null,
  isPhoneVerified: null,
  name: null,
  data:null
};
export const authSlice = createSlice({
  name: "authReducer",
  initialState,
  reducers: {
setAuth(state, action) {
  const { accessToken, ...rest } = action.payload;

  Object.keys(rest).forEach((key) => {
    if (key in state) {
      state[key] = rest[key];
    }
  });

  if (accessToken) {
    // Save token FIRST
    state.accessToken = accessToken;
    localStorage.setItem("auth-token", accessToken);

    // Decode only for user information
    try {
      const decoded = jwtDecode(accessToken);

      state.userId =
        decoded.id || action.payload.userId || state.userId;

      state.email =
        decoded.email || action.payload.email || state.email;

      state.roles =
        decoded.roles || action.payload.roles || [];

      state.role =
        decoded.role ||
        decoded.roles?.[0] ||
        action.payload.role ||
        null;
    } catch (error) {
      console.error("JWT decode failed:", error);

      // Token is already saved, so don't lose it
      state.userId = action.payload.userId || state.userId;
      state.email = action.payload.email || state.email;
      state.roles = action.payload.roles || state.roles;
      state.role = action.payload.role || state.role;
    }
  }
},

   logOut(state) {
  Object.keys(state).forEach((key) => (state[key] = null));
  localStorage.clear();
  window.location.replace("/");
},

    resetSignup(state) {
      state.phone = "";
      state.email = null;
      state.otp = "";
      state.firstName = null;
      state.lastName = null;
      state.status = null;
      state.isPhoneVerified = null;
      state.roles = [];
      state.role = null;
      state.name = null;
      state.data = null
    },
  },
});

export const { setAuth, logOut, resetSignup } = authSlice.actions;
export default authSlice.reducer;
